module.exports = __webpack_public_path__ + "img/free-2.e43d9f91.png";